<div id="viewPanel" [ngClass]="{'sidenav custom-scrollbar': true, 'closed' : !showView, 'fixed': !notFixedWidth, hide: hidePanel }">
  <!-- <div [ngClass]="{'sidenavToggle':true, 'show': !showView}">
      <a href="javascript:void(0)" class="showBtn" (click)="ShowToDo()">&#8250;</a>
  </div> -->
  <div [ngClass]="{'content': true, 'remove': !showView}">
      <div *ngIf="profileView; else menuView">
        <div class="profile-view-content">
            <p class="profile-view-title">Profile</p>
            <p class="profile-view-subtitle">Public (Not Published)</p>
        </div>
      </div>
      <ng-template #menuView>
        <div *ngIf="menu;else summaryView" class="profile-view-content">
            <ng-container *ngFor="let action of menuActions">
                <p class="action-item" (click)="onClickMenu(action)">{{ action.ActionDisplay }}</p>
            </ng-container>
            <!-- <p class="profile-view-title">Profile</p>
            <p class="profile-view-subtitle">Public (Not Published)</p> -->
        </div>
      </ng-template>
      <ng-template #summaryView>
        <div class="summaryView" *ngIf="!menu">
            <!-- <div class="dropdown btn-group dropdown-summary" dropdown container="body">
                <button dropdownToggle class="btn dropdown-summary-button arrow-right no-outline" type="button" 
                    id="dropdownMenu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Show summary
                </button>
                <ul class="dropdown-menu dropdown-menu-summary" *dropdownMenu role="menu" aria-labelledby="dropdownMenu" style="width:100%;">
                    <li><a class="dropdown-item">My Views</a></li>
                </ul>
            </div> -->
            <!-- <div class="bookmarks-container">
                <p class="bookmarks">bookmarks</p>
            </div> -->
            <div class="treeview-container custom-scrollbar">
                <div class="treeview viewList" *ngIf="systemViewList">
                    <p class="view-title" (click)="isStandardHide = !isStandardHide">Standard Bookmarks<span [class.hide]="isStandardHide"></span></p>
                    <div [ngClass]="{'tree-container': true, 'hide': isStandardHide}">
                        <app-treeview [viewList]="systemViewList" 
                        [componentId]="componentId" 
                        (viewSelected)="SelectedViewChanged($event, 'system')" 
                        [currentView]="system"
                        [draggable]="!draggable"></app-treeview>
                    </div>
                </div>
                <div class="treeview viewList" *ngIf="userViewList">
                    <p class="view-title" (click)="isUserHide = !isUserHide">My Bookmarks<span [class.hide]="isUserHide"></span></p>
                    <div [ngClass]="{'tree-container': true, 'hide': isUserHide}">
                        <app-treeview [viewList]="userViewList" 
                        [componentId]="componentId" 
                        (viewSelected)="SelectedViewChanged($event, 'user')" 
                        [currentView]="user"
                        [draggable]="draggable"></app-treeview>
                    </div>
                </div>
            </div>
        </div>
      </ng-template>
  </div>
</div>